import {
  Form,
  Button,
  Tooltip,
  Spinner,
  OverlayTrigger
} from "react-bootstrap";
import {
  faTrashAlt,
  faMagnifyingGlassLocation
} from "@fortawesome/free-solid-svg-icons";
import { useFormContext } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDialog } from "../../../../hooks/useDialog";
import { LOCAL_SEO_FIELDS_NAME } from "../../../strings";
import { useTranslation } from "react-i18next";

const DynamicFieldCityRow = ({ field }) => {
  const {
    name,
    index,
    value,
    error,
    placeholder,
    isGenerated,
    isPopulating,
    onAfterDelete,
    removeHandler,
    onPopulateClick,
    isFetchingSubDistricts = false,
    fetchingCity = null,
    fetchedCities = {},
    onFetchSubDistricts = () => {},
    parentCity = null
  } = field;

  const { t } = useTranslation();
  const {
    // control,
    register
  } = useFormContext();
  const { showConfirmationDialogBox } = useDialog();

  const handleDeleteClick = () => {
    if (isGenerated) {
      showConfirmationDialogBox({
        dialogType: "danger",
        title: t("localSeo.delDialogHeading"),
        dialogMessage: (
          <div
            dangerouslySetInnerHTML={{
              __html: t("localSeo.deleteGeneratedFieldMsg")
            }}
          />
        ),
        responseAction: (confirmed) => {
          if (confirmed && onAfterDelete) onAfterDelete();
        }
      });
    } else {
      removeHandler(index);
    }
  };

  const cityInputField = (
    <Form.Control
      placeholder={placeholder}
      disabled={isGenerated}
      {...register(`${name}.${index}.value`)}
      className={`w-25 text-capitalize ${error ? "is-invalid" : ""}`}
    />
  );

  return (
    <>
      {parentCity ? (
        <OverlayTrigger
          placement="left"
          overlay={
            <Tooltip id={`tooltip-${index}`} className="text-capitalize">
              Sub-district of {parentCity}
            </Tooltip>
          }
        >
          {cityInputField}
        </OverlayTrigger>
      ) : (
        cityInputField
      )}

      {/* ACTIONS */}
      <div className="ms-3">
        {index === 0 &&
        !isGenerated &&
        name === LOCAL_SEO_FIELDS_NAME.cities ? (
          <Button
            variant="link"
            disabled={isPopulating}
            onClick={onPopulateClick}
            className="ps-0 text-primary text-decoration-none"
          >
            {isPopulating && (
              <Spinner size="sm" className="me-2" animation="border" />
            )}
            {t("localSeo.populateCustomerCityLabel")}
          </Button>
        ) : (
          <div className="d-flex">
            <Button
              variant="outline-danger"
              onClick={handleDeleteClick}
              disabled={isFetchingSubDistricts}
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </Button>

            {isGenerated && !parentCity && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    {fetchedCities[value?.toLowerCase()]
                      ? "Fetched"
                      : "Fetch Sub-Districts"}
                  </Tooltip>
                }
              >
                <span className="d-inline-block">
                  <Button
                    className="ms-2"
                    variant="outline-success"
                    onClick={() => onFetchSubDistricts(value)}
                    disabled={
                      !value ||
                      isFetchingSubDistricts ||
                      fetchedCities[value?.toLowerCase()]
                    }
                  >
                    {fetchingCity === value?.toLowerCase() ? (
                      <Spinner size="sm" animation="border" />
                    ) : (
                      <FontAwesomeIcon icon={faMagnifyingGlassLocation} />
                    )}
                  </Button>
                </span>
              </OverlayTrigger>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default DynamicFieldCityRow;
